import { render } from "./portal-system-page.vue?vue&type=template&id=5ca9b982&scoped=true"
import script from "./portal-system-page.vue?vue&type=script&lang=js"
export * from "./portal-system-page.vue?vue&type=script&lang=js"

import "./portal-system-page.vue?vue&type=style&index=0&id=5ca9b982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca9b982"]])

export default __exports__